import { Component, OnChanges, Input, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'ep-link',
    templateUrl: './router-link.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink]
})
export class RouterLinkComponent implements OnChanges {
    routerLink: any;

    @Input() tooltip: string;
    @Input() linkUrl: string;
    @Input() linkParms: any;

    ngOnChanges(changes: any) {
        if (changes.linkUrl || changes.linkParms) {
            this.generateLink();
        }
    }

    private generateLink() {
        this.linkParms = this.linkParms || {};
        this.routerLink = [this.linkUrl, this.linkParms];
    }
}
